import {SDTKProposer} from './proposer.model';
import {Vehicle} from './vehicle.model';
import {Drivers} from './drivers.model';
import {Questions} from './questions.model';

export class SDTK {
  id = '';
  broker_id = '';
  brokerComission: number = null;
  brokerAdminFee: number = null;
  company_id = '';
  reference = '';
  status = '';
  declaration: boolean = null;
  inception_date = '';
  proposer: any = new SDTKProposer();
  ratingType = '';
  vehicles: any = [new Vehicle()];
  drivers: any = [new Drivers()];
  isReferred: boolean = null;
  policyId = '';
  effectiveDate = '';
  transactionalDate = '';
  oldPolicyId = '';
  discount = 0;
  type = 0;
  policyRefNumber: any;
  quoteMetaId: any;
  sequenceNumber: any;
  isSendEmail: any;
  data: { [key: string]: any};
  voluntaryExcess: any;
  commission: number;
  peliwica_fee: any;
  amlin_data: any;
  fleet_experiences: null;
  cover_to: any;
  excess_protect_cover_id:any;
  questions:Questions;
  sdtk_option_id:any;
  breakdown_gross:number =null;
  ipt_value:number =null;
  total_policy_cost:number =null;
  mta_reason_id:string='';
  mta_reason_other: string = '';
}
